import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs/Rx";
import { AuthService } from "./auth.service";
import { PopUpDialogComponent } from "../../components/anon/popup-dialog.component";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService,
    private router: Router,
    private dialog: PopUpDialogComponent) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    if (this.authService.isAuthenticated()) {
      if (this.authService.getUser().isAgreed == false) {
        this.router.navigate(['terms-of-service']);
        return false;
      } else if (this.authService.getUser().forcePasswordReset) {
        this.router.navigate(['change-password']);
        return false;
      } else {
        let canProceed: boolean = this.hasSecurityItem(route);

        if (canProceed) {
          return true;
        } else {
          this.router.navigate(['not-allowed']);
          return false;
        }
      }
    }

    // not logged in so redirect to login page with the return url and return false
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      let canProceed: boolean = this.hasSecurityItem(route);

      if (canProceed) {
        return true;
      } else {
        let parentUrl = state.url.slice(0, state.url.indexOf(route.url[route.url.length - 1].path));

        this.router.navigate([parentUrl, 'not-allowed']);
        return false;
      }
    }

    // not logged in so redirect to login page with the return url and return false
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  private hasSecurityItem(route: ActivatedRouteSnapshot) {
    let retObj: boolean = true;

    let item = route.data["securityItem"] as string;

    if (item != null) {

      switch (item) {
        case "canAccessPortal":
          retObj = this.authService.getUser().canAccessPortal;
          break;
        case "canAccessSearch":
          retObj = this.authService.getUser().canAccessSearch;
          break;
        case "canAccessVehicleSearch":
          retObj = this.authService.getUser().canAccessVehicleSearch;
          break;
        case "canSearchByVehiclePlateNumber":
          retObj = this.authService.getUser().canSearchByVehiclePlateNumber;
          break;
        case "canSearchByVIN":
          retObj = this.authService.getUser().canSearchByVIN;
          break;
        case "canViewClientNumber":
          retObj = this.authService.getUser().canViewClientNumber;
          break;
        case "canViewClientName":
          retObj = this.authService.getUser().canViewClientName;
          break;
        case "canViewMailingAddress":
          retObj = this.authService.getUser().canViewMailingAddress;
          break;
        case "canViewResidentialAddress":
          retObj = this.authService.getUser().canViewResidentialAddress;
          break;
        case "portal_CanViewClientDOB":
          retObj = this.authService.getUser().portal_CanViewClientDOB;
          break;
        case "canViewGender":
          retObj = this.authService.getUser().canViewGender;
          break;
        case "canViewGender":
          retObj = this.authService.getUser().canViewGender;
          break;
        case "canViewContactNumber":
          retObj = this.authService.getUser().canViewContactNumber;
          break;
        case "canViewVehicleMake":
          retObj = this.authService.getUser().canViewVehicleMake;
          break;
        case "canViewVehicleModel":
          retObj = this.authService.getUser().canViewVehicleModel;
          break;
        case "canViewVehicleYear":
          retObj = this.authService.getUser().canViewVehicleYear;
          break;
        case "canViewVehiclePlateNumber":
          retObj = this.authService.getUser().canViewVehiclePlateNumber;
          break;
        case "canViewVehicleColour":
          retObj = this.authService.getUser().canViewVehicleColour;
          break;
        case "canViewDriverLicenceNumber":
          retObj = this.authService.getUser().canViewDriverLicenceNumber;
          break;
        case "canViewDriverLicenceStatus":
          retObj = this.authService.getUser().canViewDriverLicenceStatus;
          break;
        case "canViewVehicleTypeStyle":
          retObj = this.authService.getUser().canViewVehicleTypeStyle;
          break;
        case "canViewVehicleJurisidiction":
          retObj = this.authService.getUser().canViewVehicleJurisidiction;
          break;
        case "canViewRegistrationEffectiveDate":
          retObj = this.authService.getUser().canViewRegistrationEffectiveDate;
          break;
        case "canViewRegistrationExpiryDate":
          retObj = this.authService.getUser().canViewRegistrationExpiryDate;
          break;
        case "canViewDecalId":
          retObj = this.authService.getUser().canViewDecalId;
          break;
        case "canViewRegistrationStatus":
          retObj = this.authService.getUser().canViewRegistrationStatus;
          break;
        case "canCopyToClipboard":
          retObj = this.authService.getUser().canCopyToClipboard;
          break;
        case "canViewDriverStatus":
          retObj = this.authService.getUser().canViewDriverStatus;
          break;
      }
    }

    return retObj;
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/auth/auth.guard.ts